import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";

export default class CompanyRoleSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Company Role",
            description              : "The Organization Role defines a user's access to organization-level resources and functionality, such as organization settings, the company user directory, company events, chat rooms, and more. It does not affect access to specific project resources. For project-specific access, please refer to Project Access settings.",
            svgIcon                  : "isvg-company-role",
            typeLabel                : "Access & Permissions",
            settingsUrl              : "settings/organization-role",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });
    }

}
